<template>

<com-item name="game.peers.playercounts" :size="size" :loading="loading" :is-empty="!active" title="Player Counts">

	<template v-slot:about>

		<p>What player counts the community plays at.</p>

	</template>

	<template v-slot:stats>

		<app-visualisation-bars :data="graph" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	data: function() {

		return {
			limit: 8,
			graph: {
				datasets: [
					{ type: 'bar', data: [], highlight: false, backgroundColor: '#4881bb', tooltip: '{{value}} play{{value.plural}} <small>at {{x.label}} {{x.sublabel}}</small>' }
				],
				axis: {
					x: { labels: [] },
					y: { min: 10, points: 10 }
				}
			}
		}

	},

	computed: {

		loading: function() { return this.fetching === 'all' },

		data: function() { return this.$store.getters['page/insights/game/peers'] },

		active: function() { return this.data && !this.loading && this.data.peerPlayerCounts && this.$_.keys(this.data.peerPlayerCounts).length }

	},

	created: function() { this.visualise() },

	watch: { data: function() { this.visualise() } },

	methods: {

		visualise: function() {

			if (!this.data || !this.data.peerPlayerCounts) return

			var counts = this.data.peerPlayerCounts

			this.graph.datasets[0].data = []
			this.graph.axis.x.labels = []

			var keys = Object.keys(counts).map(Number).sort(function(a, b) { return a - b })
			var max = Math.min(this.limit, keys.length ? keys[keys.length - 1] : this.limit)

			for (var i = 1; i <= max; i++) {

				this.graph.datasets[0].data.push(counts[i] || 0)
				this.graph.axis.x.labels.push({ label: i.toString(), sublabel: (i === 1) ? 'player' : 'players' })

			}

		}

	}

}

</script>

<style scoped>
</style>
